import { useEffect, useState } from 'react';
import Carousel from '@/utils/carousel'
import useFetch from '@/api/useFetch';
import styles from './Carousel.module.less'
import { useTranslation } from 'react-i18next'
function Index({ history }) {
  const { i18n } = useTranslation()
  const { response=[] } = useFetch('getBannerS', {
    lang: i18n.language
  })
  const [curTit, setCurTit] = useState({});

  useEffect(() => {
    if(response && response.length > 0) {
      Carousel('#focusPic', {
        callback: (index) => {
          setCurTit(response[index])
        }
      })
    }
  }, [response])
  
  return (
    <div id="focusPic" className={styles.carousel}>
      <ul className="carousel-pics">
      {
        response && response.map((i, index) => (
          <li key={i.qcmsdid}>
            <a href={i.url}>
              <img src={i.img} alt={i.title} />
            </a>
          </li>
        ))
      }
      </ul>
      <a className={styles.tit} href={curTit.url}>
        {curTit.title}
      </a>
      <ol className="carousel-pagin">
      </ol>
      
    </div>
  );
}

export default Index;
